/**
 * @generated SignedSource<<2db70b5d990949deb789516bf2bf00fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SaveResetViewSettingsButton$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SaveResetViewSettingsButtonCollapsible">;
  readonly " $fragmentType": "SaveResetViewSettingsButton";
};
export type SaveResetViewSettingsButton$key = {
  readonly " $data"?: SaveResetViewSettingsButton$data;
  readonly " $fragmentSpreads": FragmentRefs<"SaveResetViewSettingsButton">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "SaveResetViewSettingsButton",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SaveResetViewSettingsButtonCollapsible"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "1b783a6984cd893232aea5d467008ee0";

export default node;
